__turbopack_context__.v({
  "fallback": "uESK7q_fallback",
  "image": "uESK7q_image",
  "root": "uESK7q_root",
});
